import { queryOptions, useQuery } from '@tanstack/react-query';
import { getPage } from '@linkie/api-client';
const getPageQueryOptions = (getPageDto) => {
    return queryOptions({
        queryKey: ['linkie', getPageDto],
        queryFn: () => getPage(getPageDto),
    });
};
const useGetPage = (getPageDto, { queryConfig } = {}) => {
    return useQuery(Object.assign(Object.assign({}, getPageQueryOptions(getPageDto)), queryConfig));
};
export default useGetPage;
//# sourceMappingURL=useGetPage.hook.js.map